/**
 * @generated SignedSource<<67936ac15880e116121537100bc4f828>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookModal_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BookNow_session">;
  readonly " $fragmentType": "BookModal_session";
};
export type BookModal_session$key = {
  readonly " $data"?: BookModal_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookModal_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookModal_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookNow_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "de5a7e7b969fbc56cd0e0985c1d585b9";

export default node;
